<template>
  <div
    id="money_lose"
    class="menucontent"
    v-if="showModal"
    style="overflow-y: auto; max-height: 100%"
  >
    <div
      class="inmenucontent animate__animated animate__bounceIn"
      :style="{ backgroundImage: createBackgroundString }"
    >
      <button class="hidemenu" @click="hide">
        <i class="fas fa-times"></i>
      </button>
      <div class="ininmnct">
        <div class="menuhead mb-3">
          <i class="fas fa-share"></i> กิจกรรม FACEBOOK/TWITTER/YOUTUBE
        </div>
        <div class="modal-body -modal-body">
          <div class="x-form-register -register mt-0">
            <div class="row -animatable-container">
              <div class="col order-lg-2 order-0 -form">
                <div class="moneycontainaf1">
                  <div class="pcfriendback">
                    <div class="containlinkcopy">
                      <table style="width: 100%">
                        <tr>
                          <td
                            width="85%"
                            style="text-align: center"
                            colspan="2"
                          >
                            <div class="box1">
                              สมาชิกสามารถส่งลิ้งค์(LINK) ที่ท่านได้ แชร์ โพส
                              ทำกิจกรรมที่ช่องทางนี้เพื่อให้แอดมินตรวจสอบและอนุมัติ
                              เพื่อลุ้นรับของรางวัลต่างๆ
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td
                            width="85%"
                            style="text-align: center"
                            colspan="2"
                          ></td>
                        </tr>
                        <tr>
                          <td
                            width="85%"
                            style="text-align: center"
                            colspan="2"
                          >
                            <div class="">
                              <hr size="4" color="ffffff" width="100%" />
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td width="50%" style="text-align: center">
                            <div class="">ตัวอย่าง</div>
                          </td>
                        </tr>
                      </table>
                    </div>
                  </div>
                </div>
                <div class="friendcontent">
                  <div
                    style="
                      margin-top: 0px;
                      position: relative;
                      text-align: center;
                      z-index: 1000;
                      position: relative;
                    "
                  >
                    <table style="width: 100%">
                      <thead>
                        <tr>
                          <th>ลำดับ</th>
                          <th>Link</th>
                        </tr>
                      </thead>
                      <tr v-for="(row, index) in tableRows" :key="index">
                        <td style="vertical-align: middle">{{ index + 1 }}</td>
                        <td>
                          <input
                            style="width: 80%"
                            placeholder="กรุณาใส่ลิ้งค์ (LINK)"
                            type="text"
                            v-model="row.urlevent"
                          />
                          <input type="text" v-model="Auth.phone" hidden />
                        </td>
                        <td>
                          <button
                            class="deletebtn"
                            @click="ondeleterow(index)"
                            id="deleterow"
                          >
                            <i class="dltbut fas fa-minus"></i>
                          </button>
                        </td>
                      </tr>
                    </table>
                    <button class="addbtn" @click="addrow" id="addrow">
                      <i class="fas fa-plus"></i> เพิ่ม
                    </button>
                  </div>
                  <div class="">
                    <button
                      type="submit"
                      class="loginbtn"
                      @click="onSubmitshare"
                      id="submitReturn"
                    >
                      <i class="fas fa-inbox-out"></i> ส่งตรวจสอบกิจกรรม
                    </button>
                  </div>
                  <br />
                  <span class="detailaf">ประวัติการส่งกิจกรรม </span>

                  <div class="divoffriends">
                    <div>
                      <div>
                        <table style="width: 100%">
                          <tr>
                            <th
                              style="
                                position: relative;
                                text-align: center;
                                width: 25%;
                              "
                            >
                              <span> วันที่</span>
                            </th>
                            <th
                              style="
                                position: relative;
                                text-align: center;
                                width: 25%;
                              "
                            >
                              <span>จำนวนลิ้งค์</span>
                            </th>
                            <th
                              style="
                                position: relative;
                                text-align: center;
                                width: 25%;
                              "
                            >
                              <span>Point</span>
                            </th>
                            <th
                              style="
                                position: relative;
                                text-align: center;
                                width: 25%;
                              "
                            >
                              <span>สถานะ</span>
                            </th>
                          </tr>
                          <tr v-for="(re, index1) in history" :key="index1">
                            <td
                              style="
                                position: relative;
                                text-align: center;
                                width: 33%;
                                border-right: 1px solid;
                                font-size: 12px;
                              "
                            >
                              <span>{{ re.date }}</span>
                            </td>
                            <td
                              style="
                                position: relative;
                                text-align: center;
                                width: 33%;
                                border-right: 1px solid;
                                font-size: 12px;
                              "
                            >
                              <span>{{ re.credit }}</span>
                            </td>
                            <td
                              style="
                                position: relative;
                                text-align: center;
                                width: 33%;
                                font-size: 12px;
                              "
                            >
                              <span>สำเร็จ</span>
                            </td>
                          </tr>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="overlaymenu"></div>
  </div>
</template>

<script>
import { HTTP } from "@/services/http-common";
import { mapGetters } from "vuex";
export default {
  name: "returnlose-component",
  data() {
    return {
      tableRows: [],
      history_data:[],
      showModal: false,
      windowWidth: window.innerWidth,
      returnModal: false,
      moneyLose: "",
      withdraw: [],
      deposit: [],
      isLoading: false,
      fullPage: false,
      loader: "bars",
      date_start: "",
      date_end: "",
      history: "",
      amount: "",
      validateResult: false,
    };
  },
  methods: {
    addrow() {
      if (this.tableRows.length <= 19) {
        this.tableRows.push({ phone: this.Auth.phone, urlevent: "" });
      }
    },
    show() {
      this.fetchData();
      this.tableRows = [{ phone: this.Auth.phone, urlevent: "" }];
      this.showModal = true;
    },
    hide() {
      this.showModal = false;
      this.$emit("OpenMenuModalProp", true);
    },
    onSubmitshare() {
      this.validateResult = true;
      // for(let row in this.tableRows)
      // {
      //   if(!row.phone)
      //   {
      //     this.validateResult = false;
      //     this.$toast.error("กรุณาระบุเบอร์โทร");
      //     return;
      //   }

      //   if(!row.urlevent)
      //   {
      //     this.validateResult = false;
      //     this.$toast.error("กรุณาระบุ URL");
      //     return;
      //   }
      //   else{
      //     //validate ว่า link ถูกไหม
      //     if(!row.urlevent.includes('Facebook') || !row.urlevent.includes('Youtube'))
      //     {
      //       this.validateResult = false;
      //       this.$toast.error("invalid URL");
      //       return;
      //     }
      //   }
      // }
      for (var i = 0; i < this.tableRows.length; i++) {
        if (!this.tableRows[i].phone) {
          this.validateResult = false;
          this.$toast.error("กรุณาระบุเบอร์โทร");
          return;
        }
        if (!this.tableRows[i].urlevent) {
          this.validateResult = false;
          this.$toast.error("กรุณาระบุ URL");
          return;
        } else {
          //validate ว่า link ถูกไหม
          if (
            !this.tableRows[i].urlevent.includes("facebook") &&
            !this.tableRows[i].urlevent.includes("twitter") &&
            !this.tableRows[i].urlevent.includes("youtube")
          ) {
            this.validateResult = false;
            this.$toast.error("invalid URL");
            return;
          }
        }
      }

      if(this.validateResult) //ถ้า this.validateResult = true เราจะส่งไปค่าไป api
      {
        console.log(this.tableRows);
        let homeCont = this.$refs.homeCont;
        let loader = this.$loading.show({
          container: homeCont,
          loader: "Dots",
          color: "red",
          opacity: 0.5,
          backgroundColor: "#000000",
        });
        HTTP.post(`member/faceshare`, {
          data_table: this.tableRows,
        })
          .then((resp) => {
            if (resp.data.status != undefined && !resp.data.status) {
              this.$toast.error(
                resp.data.msg != undefined
                  ? resp.data.msg
                  : "ไม่สามารถทำรายการได้ กรุณาลองใหม่"
              );
            } else {
              this.$toast.success("บันทึกสำเร็จ");
              this.showModal = false;
            }
          })
          .catch((err) => {
            this.$toast.error(
              err.data.msg != undefined
                ? err.data.msg
                : "ไม่สามารถทำรายการได้ กรุณาลองใหม่"
            );
          })
          .then(() => {
            loader.hide();
          });
      }},
      fetchData() {
      HTTP.get(`member/faceshare`)
        .then((resp) => {
          if (resp.data.status != undefined && !resp.data.status) {
            this.$toast.error(
              resp.data.msg != undefined
                ? resp.data.msg
                : "ไม่สามารถโหลดข้อมูลได้ กรุณาลองใหม่"
            );
          } else {
            this.history_data = resp.data.data;
          }
        })
        .catch((err) => {
          this.$toast.error(
            err.data.msg != undefined
              ? err.data.msg
              : "ไม่สามารถโหลดข้อมูลได้ กรุณาลองใหม่"
          );
        });
    },
    },
    ondeleterow(index) {
      this.tableRows.splice(index, 1);
    },
    onSubmitReceive() {
      // if (this.moneyLose != 0) {
      //   this.isLoading = true;
      //   // document.getElementById("submitReturn").disabled = true;
      //   HTTP.get(`member/returnlose?receive`)
      //     .then((resp) => {
      //       // document.getElementById("submitReturn").disabled = false;
      //       if (resp.data.status != undefined && !resp.data.status) {
      //         this.hide();
      //         this.$toast.error(
      //           resp.data.msg != undefined
      //             ? resp.data.msg
      //             : "ไม่สามารถทำรายการได้ กรุณาลองใหม่"
      //         );
      //       } else {
      //         this.hide();
      //         this.fetchUserProfile();
      //         this.$toast.success(
      //           resp.data.msg != undefined ? resp.data.msg : "สำเร็จ"
      //         );
      //       }
      //     })
      //     .catch((err) => {
      //       this.$toast.error(
      //         err.data.msg != undefined
      //           ? err.data.msg
      //           : "ไม่สามารถทำรายการได้ กรุณาลองใหม่"
      //       );
      //     })
      //     .then(() => {
      //       this.isLoading = false;
      //     });
      // } else {
      //   this.$toast.error("ไม่มียอดเสีย");
      // }
      console.log("submitแล้ว");
  },
  computed: {
    ...mapGetters(["WebSetting"]),
    ...mapGetters(["Auth"]),
    createBackgroundString() {
      return `linear-gradient(140deg, ${this.WebSetting.color1}, #000000 95%), linear-gradient(180deg, #a78059 -30%, #f2d7a9 22%, #715236 72%, #f1bb73 112%)`;
    },
  },
};
</script>

<style scoped>
.-icon {
  color: white;
}
.box1 {
  background-color: rgb(135 135 135 / 50%);
  border-radius: 10px;
  color: rgb(255, 255, 255);
}
.line1 {
  width: 100%;
  color: #fff;
}
.moneycontainaf {
  width: 100%;
  background: #0000003d;
  border-radius: 20px;
  margin-top: 8px;
  text-align: left;
  color: #fff;
  font-size: 14px;
  padding: 30px 40px;
  border: 1px solid #ffe18c;
}
table td,
table td * {
  vertical-align: top;
}
.moneycontainaf1 {
  width: 100%;
  background: #000000c2;
  border-radius: 20px;
  margin-top: 8px;
  text-align: left;
  color: #fff;
  font-size: 14px;
  padding: 15px 30px 30px;
  border: 1px solid #ffe18c;
}
.divoffriends {
  text-align: center;
  background: #000000c2;
  border-radius: 20px;
  margin-top: -10px;
  height: 150px;
  overflow: auto;
  padding: 0 10px;
  padding-top: 10px;
  border: 1px solid #ffe18c;
}
.detailaf {
  background: linear-gradient(to right, #8e7050 0%, #89734c 100%);
  padding: 3px 5px;
  border-radius: 5px;
  font-size: 14px;
  font-weight: bold;
}
</style>
